import React, { useState } from 'react';

import { emitProfitBoostInfo } from '@betslip/src/services/communicator/actions';
import { useTranslation } from '@common/hooks/translation';
import { POPUPS } from '@common/constants/popups';
import Config from '@skin_config';

import './style.scss';

const FULL_DEGREE = 360;

const ProfitBoostWheel = ({ closePopup, openPopup, stakeAmount }) => {
  const t = useTranslation();
  const [rotateAngle, setRotateAngle] = useState(0);
  const [boost, setBoost] = useState(null);
  const [clicked, setClicked] = useState(false);

  const sectorCount = Config.wheelConfig.wheelBoosts.length;
  const rotationTime = (Config.wheelConfig.spinRotationCount / 2) * (1.8 * 1000);

  const generateRandomBoost = () => {
    setClicked(true);
    if (!clicked) {
      const randomArray = new Uint32Array(1);
      crypto.getRandomValues(randomArray);
      const randomIndex = randomArray[0] % Config.wheelConfig.wheelBoosts.length;
      const anglePerSector = FULL_DEGREE / sectorCount;
      const targetRotation = FULL_DEGREE - (anglePerSector * randomIndex);

      setTimeout(() => {
        setBoost(() => Config.wheelConfig.wheelBoosts[randomIndex].value);
      }, rotationTime);
      setRotateAngle((rotateAngle + targetRotation) + 360 * Config.wheelConfig.spinRotationCount);
    }
  };

  const claimBoost = () => {
    emitProfitBoostInfo(boost, stakeAmount);
    closePopup();
    openPopup(POPUPS.PROFIT_BOOST_INFO);
  };

  return (
    <div className="wheelBlock">
      <h3 className="getReady">{t('Get ready to spin!')}</h3>
      <p className="unlockedChance">{t('You have unlocked a chance to spin the wheel and win')}</p>
      <div className={`wheelContainer sectorCount-${sectorCount}`}>
        <span className="wheelBorder" />
        <span className="wheelArrow" />
        <button className="wheelButton" onClick={generateRandomBoost} disabled={clicked} type="button">
          <span className="wheelButtonText">{t('Spin')}</span>
        </button>
        <div className="spinHolder">
          <div className="rotationBlock" style={{ transform: `rotate(${rotateAngle}deg)` }}>
            {
              Config.wheelConfig.wheelBoosts.map(({ name, value }) => (
                <div className="singleSector" key={value}>
                  <div className="singleSectorTextHolder">
                    <span className="singleSectorText">{t(name)}</span>
                    <span className="singleSectorText">
                      {value === 0 ? "" : value}
                        {value !== 0 && "%"} 
                    </span>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
      {(!!boost || boost === 0)
      && (
      <button
        onClick={() => (boost === 0 ? closePopup() : claimBoost())}
        type="button"
        className="wheel-claim-btn"
      >
        {t(boost === 0 ? 'Close' : 'Claim')}
      </button>
      )}
    </div>
  );
};

export default ProfitBoostWheel;
